import { TbShirtSport } from "react-icons/tb";
import { HiOutlineTicket } from "react-icons/hi";
import { MdOutlineEventSeat, MdOutlinedFlag } from "react-icons/md";
import Link from "@mui/material/Link";

export const purchaseSeatsLanguages = {
  similarSeatModalBody: (seatTitle: string) => (
    <>
      We are going to apply the same or similar seats to all games in your pack.
      Seat locations will be visible on the checkout page.
    </>
  ),
};

export const howItWorks = [
  {
    icon: <MdOutlinedFlag />,
    title: "Select Your Pack",
    description: "Select the pack you wish to purchase.",
  },
  {
    icon: <MdOutlineEventSeat />,
    title: "Login to Account Manager",
    description:
      "Click continue and connect your Albuquerque Isotopes account using our secure Ticketmaster login.",
  },
  {
    icon: <TbShirtSport />,
    title: "Select Your Seats",
    description:
      "Select the seats you wish to purchase for the games. The same number of seats will be applied to each game in the pack.",
  },
  {
    icon: <HiOutlineTicket />,
    title: "Get Your Tickets",
    description: (
      <>
        Tickets will be available in your Isotopes{" "}
        <Link
          href={"https://am.ticketmaster.com/isotopes/"}
          target={"_blank"}
          sx={{
            color: "primary.main",
            textDecoration: "none",
            fontWeight: 500,
          }}
        >
          Account Manager
        </Link>
        . Reach out to Live Fan Support for any questions.
      </>
    ),
  },
];

export const faqs = [
  {
    title: "How does the Mariachis 6-Pack work?",
    description:
      "Get a Box Level ticket to each of our six Mariachis de Nuevo México games this season with the Mariachis 6-Pack. Simply log into your Albuquerque Isotopes Account Manager and select your seats.",
  },
  {
    title: "Do I have to select all my games now?",
    description:
      "Yes - all 6 games will automatically be added to your cart when you select the Mariachis 6-Pack.",
  },
  {
    title: "Can I choose seats throughout the venue?",
    description:
      "Yes, you can choose from all currently available inventory in the Box Level. The same number of seats and similar inventory for every game will automatically be applied.",
  },
  {
    title: "Where are event tickets delivered?",
    description: (
      <>
        Tickets will be delivered directly within your Albuquerque Isotopes{" "}
        <Link
          target={"_blank"}
          sx={{
            color: "primary.main",
            textDecoration: "none",
            fontWeight: 500,
          }}
          href={"https://am.ticketmaster.com/isotopes/"}
        >
          Account Manager
        </Link>
        .
      </>
    ),
  },
];
